;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { z } from "zod/v4";
import { NotificationStatus } from "@/types/enums";

/**
 * Schema to update a notification preference
 */
export const updateNotificationSchema = z.object({
	emailEnabled: z.boolean().default(false),
});

export const updateUserNotificationStatusSchema = z.object({
	ids: z.array(
		z.object({
			id: z.string(),
			subscriberId: z.string().nullable(),
			workflowId: z.string().nullable(),
		}),
	),
	status: z.enum(Object.values(NotificationStatus) as [string, ...string[]]),
});

export type UpdateNotificationSchema = z.infer<typeof updateNotificationSchema>;
export type UpdateUserNotificationStatusSchema = z.infer<
	typeof updateUserNotificationStatusSchema
>;
